/* @flow */

import { tintDuration } from '@e180/ui/lib/token/animation';
import { minTargetSize } from 'src/shared/app/base/style/token/box';
import { darkBaseColor } from '@e180/ui/lib/token/color';
import { pushDown } from 'src/shared/app/base/style/token/helper';
import { tablet } from '@e180/ui/lib/token/mediaQuery';
import { hoverSelector } from '@e180/ui/lib/token/selector';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',

    minWidth: minTargetSize,
    height: '100%',
    padding: [16, 8, 4],

    color: 'currentColor',

    textAlign: 'center',
    textDecoration: 'none',

    transition: ['background-color', tintDuration],

    [hoverSelector]: {
      backgroundColor: darkBaseColor,
    },
    '&:active': {
      extend: pushDown,
    },
    '&:focus': {
      outlineOffset: -1,
    },

    [tablet]: {
      position: 'relative',

      flexDirection: 'row',
      justifyContent: 'flex-start',

      height: 'auto',
      padding: [16, 4, 16, 52],

      textAlign: 'left',

      '&:focus': {
        outlineOffset: 0,
      },
    },
  },
  'root-isSelected': {
    backgroundColor: 'transparent',
    color: ({ accentColor }: Object) => [accentColor, '!important'],

    pointerEvents: 'none',
  },
  icon: {
    [tablet]: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 4,

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  label: {
    width: '100%',
    overflow: 'hidden',

    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
